import Crud from '../components/BreakdownTypes/Crud'
import Add from '../components/BreakdownTypes/Add'

let routes = {
    path: '/breakdownTypes',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/breakdownTypes/add',
            name: 'Novo Avaria',
            component: Add
        },
        {
            path: '/breakdownTypes/edit/:id?',
            name: 'Editar Avaria',
            component: Add
        },
        {
            path: '/breakdownTypes',
            name: 'Avarias',
            component: Crud
        },
    ]
};


export default routes



// WEBPACK FOOTER //
// ./src/router/breakdown-types.js